<template>
    <section class="chat-settings" v-if="getState && getChat" @click="closeAll()">
            <div class="chat-settings-container" @click.stop>

                    <div class="confirm" v-if="leave">
                        <div class="confirm-container">
                        <h5>Вы действительно хотите выйти из чата?</h5>
                        <div class="confirm-buttons">
                            <div class="button" @click="leaveChat()">Да</div>
                            <div class="button" @click="leave = false">Нет</div>
                        </div>
                        </div>
                    </div>
                    <div class="confirm" v-if="deleting">
                        <div class="confirm-container">
                        <h5>Вы действительно хотите удалить чат?</h5>
                        <div class="confirm-buttons">
                            <div class="button" @click="deleteChat()">Да</div>
                            <div class="button" @click="deleting = false">Нет</div>
                        </div>
                        </div>
                    </div>
                
                    <div class="chat-settings__avatar" :style="{ backgroundImage: 'url(' + getCover + ')' }">
                    <input
                        class="card-panel__input"
                        type="file"
                        @change="loadPhoto($event, 'avatars')"
                        name="avatar"
                        max-size="10000"
                        accept="image/*"
                        title="Изменить аватарку"
                        v-if="!isDialog"
                    />
                        <font-awesome-icon icon="pencil-alt" v-if="!new_cover && !loading" class="chat-settings__avatar_edit" />
                        <div v-else-if="loading" class="card__avatar_loader">
                            <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform 
                                attributeName="transform" 
                                attributeType="XML" 
                                type="rotate"
                                dur="1s" 
                                from="0 50 50"
                                to="360 50 50" 
                                repeatCount="indefinite" />
                            </path>
                        </svg>
                        </div>
                        <div class="dialog-collage" v-if="!isDialog && !getChat.cover" :class="getClassCount">
                            <div class="dialog-collage__item" v-for="user in getChat.users" :key="user.id" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"></div>
                        </div>
                    
                    </div>
                    <p class="chat-settings__title" v-if="getUser.id !== getChat.author_id || isDialog">{{ isDialog ? getNameOponent : getChat.caption }}</p>
                    <input class="chat-settings__caption" :placeholder="getChat.caption" v-if="!isDialog && getUser.id === getChat.author_id" v-model="new_title" @blur="updateChatTitle" />
                    <div class="chat-settings__users" v-if="!isDialog">{{ getChat.users.length }} участников</div>
                    <div class="chat-settings__line"></div>
                    <ul class="chat-settings-list">
                        <!-- <li class="chat-settings-button" @click="$store.dispatch('changeState', {element: 'invite', val: true})">
                            <font-awesome-icon icon="user-plus" />
                            <p>Добавить участников</p>
                        </li> -->
                        <router-link tag="li" class="chat-settings-button" v-if="getChat.event" :to="{name: 'event', params: { hash: getChat.event.id + '&' + getChat.event.hash }}">
                            <font-awesome-icon icon="map-marker-alt" />
                            <p>Перейти к ивенту</p>
                        </router-link>
                        <li class="chat-settings-button" v-if="!isDialog" @click="openParty()">
                            <font-awesome-icon icon="user-plus" />
                            <p>Участники чата</p>
                        </li>
                        <li class="chat-settings-button" v-if="!chatIsMuted" @click="turnNotif()">
                            <font-awesome-icon icon="bell-slash" />
                            <p>Выключить уведомления</p>
                        </li>
                        <li class="chat-settings-button" v-if="chatIsMuted" @click="turnNotif()">
                            <font-awesome-icon icon="bell" />
                            <p>Включить уведомления</p>
                        </li>
                        <li class="chat-settings-button" v-if="!isDialog && !chatIsPublic && getUser.id === getChat.author_id" @click="changePrivate()">
                            <font-awesome-icon icon="lock-open" />
                            <p>Сделать чат открытым</p>
                        </li>
                        <li class="chat-settings-button" v-if="chatIsPublic && getUser.id === getChat.author_id" @click="changePrivate()">
                            <font-awesome-icon icon="lock" />
                            <p>Сделать чат закрытым</p>
                        </li>
                        <li class="chat-settings-button danger" v-if="!isDialog" @click="leave = !leave">
                            <font-awesome-icon icon="sign-out-alt" />
                            <p>Выти из чата</p>
                        </li>
                        <li class="chat-settings-button danger" v-if="getUser.id === getChat.author_id" @click="deleting = !deleting">
                            <font-awesome-icon icon="trash-alt" />
                            <p>Удалить чат</p>
                        </li>
                    </ul>
        </div>
    </section>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faUsersCog,faSignOutAlt, faUserPlus, faBellSlash, faLockOpen, faLock, faBell} from '@fortawesome/free-solid-svg-icons'
library.add(faTrashAlt, faUsersCog,faSignOutAlt, faUserPlus, faBellSlash, faLockOpen, faLock, faBell)

export default {
    name: 'AddChat',
    data: () => {
        return {
            added: [],
            locked: false,
            title: '',
            can_add: true,
            leave: false,
            deleting: false,
            new_cover: null,
            new_title: null,
            loading: false
        }
    },
    computed: {
        getState () {
            return this.$store.getters.chat_settings
        },
        getUser () {
            return this.$store.getters.getAuthUser
        },
        getChat() {
            return this.$store.getters.getActiveChat
        },
        chatIsMuted() {
            let muted = this.getUser.muted_chats;
            return muted ? muted.find(item => item === this.getChat.id) : []
        },
        chatIsPublic() {
            return this.getChat.public
        },
        getClassCount() {
            let result = 'one';
            if (this.getChat.users.length > 3) {
            result = 'four'
            } else if (this.getChat.users.length == 2) {
            result = 'two'
            } else if (this.getChat.users.length == 3) { 
            result = 'tree'
            }
            return result
        },
        isDialog() {
            return this.getChat.type === 'dialog'
        },
        getOponent() {
            return this.getChat.users.find(user => user.id !== this.getUser.id);
        },
        getNameOponent() {
            return this.getOponent.firstname + ' ' + this.getOponent.lastname
        },
        getCover () {
            return this.isDialog ? this.getAvatar(this.getOponent) : this.getChat.cover
        }
    },
    sockets: {
        update_chat_caption (chat) {
            chat && !chat.error ? this.$router.push({name: 'chat', params: {
                hash: chat.id + '&' + chat.hash
            }}) : this.$store.dispatch('addError', {message: 'Не удалось загрузить изменения.'})
        },
        change_mute (mutes) {
            if (mutes) {
                mutes && mutes.muted && mutes.muted.find(chat => chat === this.getChat.id) ? this.$store.dispatch('addNotification', {message: 'Уведомления этого чата отключены!'}) : this.$store.dispatch('addNotification', {message: 'Уведомления этого чата включены!'});
                this.$store.dispatch('getAuthUser', {user: this.getUser.id});
            }
        },
        change_cover (chat_cover) {
            this.$store.dispatch('editChat', {key: 'cover', val: chat_cover})
        },
        change_private (public_chat) {
            let chat = this.getChat;
            chat.public = public_chat
            this.$store.dispatch('setChat', chat)
        }
    },
    methods: {
        getAvatar(user) {
            return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
        },
        updateChatTitle() {
            if (this.new_title && this.new_title.length > 0) {
                if (this.new_title !== this.getChat.caption) {
                    this.$socket.emit('update_chat_caption', {caption: this.new_title, id: this.getChat.id})
                }
            } else {
                this.$store.dispatch('addError', {message: 'Нельзя ввести пустое название для чата'})
            }
        },
        loadPhoto(input) {
            let element = input.target.files[0];
            if (element.size / 1024 > 10000) {
                this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 5MB'});
            } else {

                var reader = new FileReader();
                reader.readAsDataURL(element)
                reader.onload = async () => {
                let url = reader.result;
                let type = element.type.split('/')[1];
                let size = element.size / 1024;
                let path = 'chats';
                let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
                this.loading = true;
                await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path, resize: 70})
                    .then(response => {
                        this.loading = false;
                        if (response.Location) {
                            this.updateCover(response.Location)
                        } else {
                            this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                        }
                    }).catch(e => {e
                        this.loading = false;
                        this.new_cover = null;
                        this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                    });
                };

                reader.onerror = function() {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                };
                
            }
        },
        updateCover(cover) {
            this.$store.dispatch('deleteImage', {key: this.getChat.cover})
            this.$socket.emit('update_chat_cover', {cover, id: this.getChat.id})
        },
        leaveChat() {
            let chat = this.getChat;
            let user = this.getUser;
            user = {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname
            };
            let new_admin = chat.author_id === user.id ? chat.users[0].id !== user.id ? chat.users[0].id : chat.users[1] ? chat.users[1].id : -1 : null;

            let data = {
                chat: chat.id,
                user: user,
                admin: new_admin
            };
            this.$socket.emit('leave_chat', data)
            this.closeAll()
            this.$store.dispatch('removeChat', this.getChat.id)
            this.$store.dispatch('changeState', {element: 'chat_list', val: true})
            this.$router.push({name: 'messages'})
        },
        async deleteChat() {
            let chat = this.getChat;
            let data = {
                chat_id: chat.id
            };
            let result = await this.$store.dispatch('deleteChat', data);
            if (result) {
                this.closeAll()
                this.$store.dispatch('removeChat', chat.id)
                this.$store.dispatch('setActiveChat', null)
                this.$store.dispatch('addNotification', {message: `Чат «${result.caption}» был удален.`})
                this.$store.dispatch('changeState', {element: 'chat_list', val: true})
                this.$router.push({name: 'messages'})
            }
        },
        closeAll () {
            this.leave = false
            this.$store.dispatch('changeState', {element: 'chat_settings', val: false})
        },
        turnNotif () {
            let chat = this.getChat;
            let user = this.getUser;
            let muted = user.muted_chats ? user.muted_chats : [];
            let finded = muted.find(item => item === chat.id);
            finded ? muted.splice(muted.indexOf(finded), 1) : muted.push(chat.id);
            this.$socket.emit('change_mute', {muted: muted, user: user.id})
        },
        changePrivate () {
            let chat = this.getChat;
            let user = this.getUser;
            user = {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname
            };
            this.$socket.emit('change_private', {chat: chat.id, public: !chat.public, user: user})
        },
        async openParty() {
            await this.$store.dispatch('setChatParty', this.getChat.users)
            this.$store.dispatch('changeState', {element:'party'})
        },
    },
    watch: {
        getChat(chat) {
            this.new_title = chat ? chat.caption : null
        }
    }
}
</script>